import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

const Option = (props) => {
    const {
        label, className, clickable, isCategory, isSubCategory,
        highlighted, disabled, onFocus, onBlur, intl,
        onClick,
    } = props;

    const classNames = `
        kbe-option-list-item
        ${isCategory ? 'category-title' : ''}
        ${isSubCategory ? 'subcategory-tlte' : ''}  
        ${clickable ? 'clickable' : ''}
        ${disabled ? 'disabled' : ''}
        ${highlighted ? 'highlighted' : ''}
        ${className}
    `;

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div
            className={classNames}
            role="option"
            tabIndex={0}
            onFocus={() => onFocus(label)}
            onBlur={onBlur}
            aria-selected={highlighted}
            onClick={onClick}
        >
            {
                label !== 'Hotels' ? label : intl.formatMessage({ id: 'bf.hotels', defaultMessage: 'bf.hotels' })
            }
        </div>
    );
};

Option.defaultProps = {
    className     : '',
    clickable     : true,
    isCategory    : false,
    isSubCategory : false,
    highlighted   : false,
    disabled      : false,
    onFocus       : () => {},
    onBlur        : () => {},
    onClick       : () => {},
};

Option.propTypes = {
    label         : PropTypes.oneOfType([ PropTypes.element, PropTypes.string ]).isRequired,
    className     : PropTypes.string,
    clickable     : PropTypes.bool,
    isCategory    : PropTypes.bool,
    isSubCategory : PropTypes.bool,
    highlighted   : PropTypes.bool,
    disabled      : PropTypes.bool,
    onFocus       : PropTypes.func,
    onBlur        : PropTypes.func,
    onClick       : PropTypes.func,
    intl          : PropTypes.shape(intlShape).isRequired,
};

export default injectIntl(Option);
